<form class="content-card">
  <div class="row">
    <div class="col-md-10 col-sm-12">
      <app-agreement-picker [agreements]="agreements | async" [(agreementSelection)]="workerAgreement" (agreementSelectionChange)="onAgreementSelection()"></app-agreement-picker>
    </div>
  </div>
  @if (workerAgreement?.HasAbsences) {
    <div class="row">
      <div class="col-md-12 col-sm-12 text-right">
        <button mat-raised-button color="primary" [disabled]="!workerAgreement" (click)="openAbsenceModal()">
          {{ 'CreateAbsence' | translate }}
        </button>
      </div>
    </div>
  }
</form>
<mat-tab-group (selectedTabChange)="onTabChanged($event)">
  @if (workerAgreement?.HasAbsences) {
    <mat-tab [label]="'WorkerAbsenceLimitsTab' | translate">
      <app-worker-absence-limits-list [refreshToken]="refreshToken" [workerAgreementId]="workerAgreement?.Id"></app-worker-absence-limits-list>
    </mat-tab>
  }
  @if (workerAgreement?.HasAbsences) {
    <mat-tab [label]="'WorkerAbsenceListTab' | translate">
      <app-worker-absences-list
        [refreshToken]="refreshToken"
        (refreshTokenChange)="changeRefreshToken($event)"
        [workerAgreementId]="workerAgreement?.Id"
        ></app-worker-absences-list
      ></mat-tab>
    }
    @if (workerAgreement?.HasSickLeaves) {
      <mat-tab [label]="'WorkerIllnessTab' | translate">
        <app-worker-illness-list [refreshToken]="refreshToken" [workerAgreementId]="workerAgreement?.Id"></app-worker-illness-list
        ></mat-tab>
      }
    </mat-tab-group>